import { IChannel } from '@boc/framework/channels/types';
import { boc, mantiq } from '@boc/organization/entities';

export const channels: { [key: string]: IChannel } = {
  in: {
    slug: 'jsn-in',
    urlSlug: 'in',
    name: 'India',
    defaultCountry: 'IN',
    defaultCurrency: 'INR',
    defaultLocale: 'EN',
    paymentMethod: 'razorpay',
    entity: { ...boc, logo: '/static/entity-boc.png' },
    seo: {
      title: (title) => `${title} in India`,
      description: (description) =>
        `${description}. Buy the best puzzles 100 piece, 500 piece, 1000 piece jigsaw puzzles for kids and adults. Shipping to all cities in India including Mumbai, Pune, Bangalore, Chennai!`,
    },
  },
  ae: {
    slug: 'jsn-ae',
    urlSlug: 'ae',
    name: 'UAE',
    defaultCountry: 'AE',
    defaultCurrency: 'AED',
    defaultLocale: 'EN',
    paymentMethod: 'paymennt',
    entity: { ...mantiq, logo: '/static/entity-mantiq.png' },
    seo: {
      title: (title) => `${title} in UAE`,
      description: (description) =>
        `${description}. Buy the best puzzles 100 piece, 500 piece, 1000 piece jigsaw puzzles for kids and adults. Shipping to all emirates in the UAE, to Abu Dhabi, Dubai, Sharjah, Ajman, Umm Al Quwain, Ras Al Khaimah and Fujairah!`,
    },
    supportedCountries: ['IN', 'AE'],
  },
  intl: {
    slug: 'jsn-intl',
    urlSlug: 'intl',
    name: 'World',
    defaultCountry: 'US',
    defaultCurrency: 'USD',
    defaultLocale: 'EN',
    paymentMethod: 'razorpay',
    entity: { ...boc, logo: '/static/entity-boc.png' },
    seo: {
      title: (title) => `${title}`,
      description: (description) =>
        `${description}. Buy the best puzzles 100 piece, 500 piece, 1000 piece jigsaw puzzles for kids and adults. Worldwide shipping available!`,
    },
    supportedCountries: [
      'US', // United States
      'GB', // United Kingdom
      'CA', // Canada
      'AU', // Australia
      'NZ', // New Zealand
      'SG', // Singapore
      'MY', // Malaysia
      'JP', // Japan
      'KR', // South Korea
      'HK', // Hong Kong
      'TW', // Taiwan
      'TH', // Thailand
      'PH', // Philippines
      'ID', // Indonesia
      'VN', // Vietnam
      'MX', // Mexico
      'BR', // Brazil
      'AR', // Argentina
      'CL', // Chile
      'CO', // Colombia
      'PE', // Peru
      'ZA', // South Africa
      'EG', // Egypt
      'SA', // Saudi Arabia
      'TR', // Turkey
      'DE', // Germany
      'FR', // France
      'IT', // Italy
      'ES', // Spain
      'NL', // Netherlands
      'BE', // Belgium
      'AT', // Austria
      'CH', // Switzerland
      'PL', // Poland
      'CZ', // Czech Republic
      'SK', // Slovakia
      'HU', // Hungary
      'RO', // Romania
      'BG', // Bulgaria
      'GR', // Greece
      'PT', // Portugal
      'SE', // Sweden
      'DK', // Denmark
      'FI', // Finland
      'NO', // Norway
      'IE', // Ireland
      'LU', // Luxembourg
    ],
  },
};

export const DEFAULT_CHANNEL = channels.in;
